<template>
    <div class="container">
        <div class="field">
            <p v-text="lang('Per una corretta gestione e archiviazione dei preventivi la compilazione dei campi è obbligatoria')"></p>
        </div>
      <div class="columns">
        <div class="column">
          <radio-field :label="lang('Tipologia Utente')" name="type" id="type" v-model="input.type" value="privato" :errors="registryErrors" :options="types.details" required></radio-field>
        </div>
      </div>
      <div class="columns" v-if="input.type === 'azienda'">
        <div class="column is-half">
          <select-fetch v-model="input.title" :label="lang('Qualifica')" name="title"
                        :options="titles" :errors="registryErrors" required></select-fetch>
        </div>
        <div class="column is-half">
          <input-field :label="lang('Ragione Sociale')" name="company"
                       :errors="registryErrors"
                       v-model="input.company"></input-field>
        </div>
      </div>
      <div class="columns">
        <div class="column is-4" v-if="input.type !== 'azienda'">
          <select-fetch v-model="input.title" :label="lang('Qualifica')" name="title"
                        :options="titles" :errors="registryErrors" required></select-fetch>
        </div>
        <div class="column" :class="{ 'is-half': input.type === 'azienda', 'is-4': input.type === 'privato'}">
          <input-field :label="lang('Nome')"
                       name="firstname"
                       :errors="registryErrors"
                       v-model="input.firstname"
                       required></input-field>
        </div>
        <div class="column" :class="{ 'is-half': input.type === 'azienda', 'is-4': input.type === 'privato'}">
          <input-field :label="lang('Cognome')" name="lastname"
                       :errors="registryErrors"
                       v-model="input.lastname"
                       required></input-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <select-fetch v-model="input.buyer_type"
                        :label="lang('Richiedente')"
                        name="buyer_type"
                        :options="buyersTypes"
                        :errors="registryErrors"
                        required>

          </select-fetch>
        </div>
      </div>

      <div class="columns">
        <div class="column is-8">
          <input-field :label="lang('Indirizzo')" name="address"
                       :errors="registryErrors"
                       v-model="input.address"
                       required></input-field>
        </div>

        <div class="column is-4">
          <input-field :label="lang('C.A.P.')" name="zip"
                       :errors="registryErrors"
                       v-model="input.zip"
                       required></input-field></div>

      </div>

      <div class="columns">
        <div class="column is-half">
          <input-field :label="lang('Comune')" name="city"
                       :errors="registryErrors"
                       v-model="input.city"
                       required></input-field>
        </div>
        <div class="column is-half">
          <select-fetch v-if="language === 'it'" v-model="input.province" :label="lang('Provincia')"
                        name="province"
                        :options="provinces" :errors="registryErrors" required></select-fetch>
          <select-fetch v-else v-model="input.country" :label="lang('Paese')" name="country"
                        :options="countries" :errors="registryErrors" required></select-fetch>
        </div>
      </div>
      <div class="columns">
        <div class="column is-half">
          <input-field :label="lang('Indirizzo Email')" name="email"
                       type="email"
                       :errors="registryErrors"
                       v-model="input.email"
                       required></input-field>
        </div>
        <div class="column is-half">
          <input-field :label="lang('Telefono')" name="phone"
                       type="phone"
                       :errors="registryErrors"
                       v-model="input.phone"
                       required></input-field>
        </div>
      </div>
    </div>
</template>
<script>
    import FormErrors from '../Classes/FormErrors'
    import Radio from "./Radio";

    export default {
      components: {Radio},
      props: {
            value: {
                type: Object,
                required: false
            },
            errors: {
                type: Object,
                required: true
            },
            provinces: {
                type: Array,
                required: true
            },
            countries: {
                type: Array,
                required: true
            },
            titles: {
                type: Array,
                required: true
            },
            buyersTypes: {
              type: [Array, Object],
              required: true
            }
        },
        data() {
            return {
                input: {
                    type: 'privato',
                    company: '',
                    firstname: '',
                    lastname: '',
                    title: '',
                    buyer_type: '',
                    email: '',
                    phone: '',
                    address: '',
                    city: '',
                    zip: '',
                    province: '',
                    country: 1
                },
                types: {
                  title: "Seleziona tipologia utente",
                  details: [
                    {
                      name: "Privato",
                      value: "privato",
                      checked: 'checked',
                    },
                    {
                      name: "Azienda",
                      value: "azienda",
                    }
                  ],
                },
                registryErrors: new FormErrors(),
                completed: false
            }
        },
        mounted() {
            if (typeof this.value === 'object') this.input = this.value;
        },
        methods: {
            sendData() {
                this.checkComplete();
                this.$emit('input', this.input)
            },
            checkComplete() {
                let completed = true;
                for (let [key, val] of Object.entries(this.input)) {
                    if (key === 'company') continue;
                    if (val === '') completed = false;
                }
                this.completed = completed;
            }
        },
        watch: {
            completed(val) {
                if (val) this.$emit('completed')
            },
            input: {
                handler() {
                    this.sendData()
                },
                deep: true
            },
            errors(errors) {
                if (errors.registry) {
                    this.registryErrors.record(errors.registry);
                }
            }
        },
        computed: {
            language() {
                return window.language;
            }
        }
    }
</script>
